import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { ExperimentKeys } from '../experiments/ExperimentKeys';
import { ExperimentParameterGroup } from '../experiments/ExperimentParameterGroup';
import { TrackWhen, useExperiment } from '../experiments/useExperiment';
import { Text } from 'foundations-components/components/Text';
import { Data } from 'signup-constants/signupData/Data';
import { jsx as _jsx } from "react/jsx-runtime";
const acq165LabelOverride = label => /*#__PURE__*/_jsx(FormattedJSXMessage, {
  elements: {
    Highlight: ({
      children
    }) => /*#__PURE__*/_jsx(Text, {
      as: "span",
      typography: "heading-100",
      children: children
    })
  },
  message: `data.${Data.Email}.${label}`
});
const ACQ165Labels = {
  [ExperimentParameterGroup.Variant_A]: 'acq0165LabelA_jsx',
  [ExperimentParameterGroup.Variant_B]: 'acq0165LabelB_jsx'
};
export const useACQ0165 = () => {
  const {
    isAssignedToSpecificVariant
  } = useExperiment(ExperimentKeys.ACQ0165, TrackWhen.enrolled);
  const {
    isAssignedToSpecificVariant: isAssignedToACQ167Variant_B
  } = useExperiment(ExperimentKeys.ACQ0167, TrackWhen.never);
  if (isAssignedToSpecificVariant(ExperimentParameterGroup.Variant_A)) {
    return {
      labelOverride: acq165LabelOverride(ACQ165Labels[ExperimentParameterGroup.Variant_A])
    };
  }
  if (isAssignedToSpecificVariant(ExperimentParameterGroup.Variant_B) || isAssignedToACQ167Variant_B(ExperimentParameterGroup.Variant_B)) {
    return {
      labelOverride: acq165LabelOverride(ACQ165Labels[ExperimentParameterGroup.Variant_B])
    };
  }
  return {
    labelOverride: null
  };
};